import { toSnakeCase } from "../../../../helpers";
import Tabs from "../../../../components/elements/Tabs";
import { useTranslation } from "react-i18next";
import List from "../../../../components/sections/admin/user/List";
import PrivacyAndSecurity from "../../../../components/sections/admin/user/PrivacyAndSecurity";
import BulkUploadUser from "../../../../components/sections/admin/user/BulkUploadUser";
import CustomAttributes from "../../../../components/sections/admin/user/CustomAttributes";
import NotFoundPage from "../../../../components/common/NotFoundPage";
import { useTabQuery } from "../../../../hooks/useTabQuery";
import { useMemo } from "react";
import { setTitle } from "../../../../helpers/MetaTag";
import FileManager from "../../../../components/sections/admin/media/FileManager";

const Media = () => {
  const { t } = useTranslation();
  setTitle("Media");
  const tabs = useMemo(
    () => [
      {
        label: "Media Dashboard",
        icon: "fa-regular fa-grid-horizontal",
        content: <FileManager viewAll={false} />,
        key: "media-dashboard",
      },
      {
        label: "All Media",
        icon: "fa-regular fa-photo-film-music",
        content: <FileManager viewAll={true} />,
        key: "media-list",
      },
      {
        label: "Recycle Bin",
        icon: "fa-regular fa-bin-recycle",
        content: "<CustomAttributes />",
        key: "recyclebin",
      },
    ],
    []
  );

  const { selectedIndex, handleTabChange, validTab } = useTabQuery(tabs);

  if (!validTab) {
    return <NotFoundPage link="/admin/media?tab=media-list" />;
  }

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-6">
        <div className="font-semibold text-lg xls:text-sm xl:text-3xl text-primary text-right xls:text-left">
          Media Management
        </div>
        <Tabs
          items={tabs}
          selectedIndex={selectedIndex}
          setSelectedIndex={handleTabChange}
          tabsClass={"gap-3"}
        />
      </div>
    </div>
  );
};

export default Media;
